import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';

const EditLanguage = ({ show, onClose, languageId, onUpdated }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [name, setName] = useState('');
  // const [code, setCode] = useState('');
  const [errors, setErrors] = useState({});
  const [nameLengthError, setNameLengthError] = useState('');
  // const [codeLengthError, setCodeLengthError] = useState('');

  useEffect(() => {
    if (show && languageId) {
      axios.get(`${baseURL}/language/${languageId}`)
        .then(response => {
          const { language_name } = response.data.data;
          
          // const { language_name, language_code } = response.data.data;
          setName(language_name || '');
          // setCode(language_code || '');
        })
        .catch(error => {
          console.error("Error fetching language:", error);
        });
    }
  }, [show, languageId]);

  const handleNameChange = (e) => {
    let value = e.target.value || '';
    value = value.charAt(0).toUpperCase() + value.slice(1);
    setName(value);

    if (value.length <= 100) {
      setNameLengthError('');
    }
  };

  // const handleCodeChange = (e) => {
  //   let value = e.target.value || '';
  //   value = value.charAt(0).toUpperCase() + value.slice(1);
  //   setCode(value);

  //   if (value.length <= 10) {
  //     setCodeLengthError('');
  //   }
  // };

  const handleSubmit = () => {
    setErrors({});
    setNameLengthError('');
    // setCodeLengthError('');

    const safeName = name.trim();
    // const safeCode = code.trim();

    if (!safeName) {
      setErrors(prev => ({
        ...prev,
        language_name: "This field is required"
      }));
      return;
    }

    if (safeName.length > 100) {
      setNameLengthError('Limit reached (max 100 characters)');
      return;
    }

    // if (!safeCode) {
    //   setErrors(prev => ({
    //     ...prev,
    //     language_code: "This field is required"
    //   }));
    //   return;
    // }

    // if (safeCode.length > 10) {
    //   setCodeLengthError('Limit reached (max 10 characters)');
    //   return;
    // }

    axios.post(`${baseURL}/language/${languageId}`, {
      language_name: safeName,
      // language_code: safeCode,
    })
    .then(() => {
      onClose();
      if (onUpdated) onUpdated();
    })
    .catch(error => {
      if (error.response?.status === 400) {
        const data = error.response.data;

        if (data.errors) {
          setErrors(data.errors);
        } else if (data.message) {
          if (data.message.toLowerCase().includes('already exists')) {
            setErrors(prev => ({
              ...prev,
              language_name: data.message
            }));
          } else {
            setErrors(prev => ({
              ...prev,
              language_name: data.message
            }));
          }
        }
      } else {
        console.error("Update failed:", error);
      }
    });
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Update Language</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Language<span className="required">*</span></label>
              <input
                type="text"
                className={`form-control ${errors.language_name ? 'is-invalid' : ''}`}
                placeholder="Enter Language"
                value={name}
                onChange={handleNameChange}
              />
              {errors.language_name && (
                <div className="invalid-feedback">
                  {Array.isArray(errors.language_name) ? errors.language_name[0] : errors.language_name}
                </div>
              )}
              {nameLengthError && <span className="text-danger">{nameLengthError}</span>}
            </div>

            {/* <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Language Code<span className="required">*</span></label>
              <input
                type="text"
                className={`form-control ${errors.language_code ? 'is-invalid' : ''}`}
                placeholder="Enter Language Code"
                value={code}
                onChange={handleCodeChange}
              />
              {errors.language_code && (
                <div className="invalid-feedback">
                  {Array.isArray(errors.language_code) ? errors.language_code[0] : errors.language_code}
                </div>
              )}
              {codeLengthError && <span className="text-danger">{codeLengthError}</span>}
            </div> */}
          </div>

          <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
            <Button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>
              Update Language <i className="fas fa-angle-double-right ms-2"></i>
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditLanguage;
